module.exports = __webpack_public_path__ + "img/celebration.42730a0a.png";